(() => {
  const ready = callback => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  ready(() => {
    document.addEventListener('click', event => {
      const opener = event.target.closest('[data-quick-view-open]');
      if (!opener) return;
      const dialog = opener.closest('.product-card')?.querySelector('[data-quick-view]');
      dialog?.addEventListener('close', () => opener.focus(), { once: true });
    });

    const popup = document.querySelector('[data-newsletter-popup]');
    if (!popup) return;

    const storageVersion = popup.dataset.storageVersion || '1';
    const storageKey = `everword-newsletter-popup-${storageVersion}`;
    const now = Date.now();
    const configuredDelay = Math.max(0, Number(popup.dataset.delay || 12));
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const delay = (isMobile ? Math.min(configuredDelay, 8) : configuredDelay) * 1000;
    const reopenDays = Math.max(1, Number(popup.dataset.reopenDays || 14));
    const submitted = popup.dataset.submitted === 'true';
    let state = {};

    try { state = JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (error) { state = {}; }

    const persist = days => {
      try { localStorage.setItem(storageKey, JSON.stringify({ hiddenUntil: now + days * 86400000 })); } catch (error) {}
    };
    const open = () => {
      if (!popup.hidden) return;
      popup.hidden = false;
      document.documentElement.classList.add('is-scroll-locked');
      if (!isMobile) popup.querySelector('input[type="email"]')?.focus();
    };
    const close = () => {
      popup.hidden = true;
      document.documentElement.classList.remove('is-scroll-locked');
      persist(submitted ? 90 : reopenDays);
    };

    popup.querySelectorAll('[data-newsletter-close]').forEach(button => button.addEventListener('click', close));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !popup.hidden) close();
    });

    if (submitted) {
      persist(90);
      open();
      return;
    }
    if (Number(state.hiddenUntil || 0) > now) return;

    let opened = false;
    const openOnce = () => {
      if (opened) return;
      const anotherOverlayIsOpen = document.querySelector('.ew-cart-drawer:not([hidden]),.ew-contact-drawer:not([hidden]),.predictive-search-drawer:not([hidden]),dialog[open]');
      if (anotherOverlayIsOpen) return;
      opened = true;
      open();
    };
    window.setTimeout(openOnce, delay);
    window.addEventListener('scroll', () => {
      const pageHeight = document.documentElement.scrollHeight - window.innerHeight;
      const threshold = window.matchMedia('(max-width: 989px)').matches ? 0.12 : 0.35;
      if (pageHeight > 0 && window.scrollY / pageHeight >= threshold) openOnce();
    }, { passive: true });
    if (window.matchMedia('(min-width: 990px)').matches) {
      document.addEventListener('mouseout', event => {
        if (event.clientY <= 0 && !event.relatedTarget) openOnce();
      });
    }
  });
})();

